export abstract class StepModel{
    private _title: string = ''
    private _startDate: string = ''
    private _endDate: string = ''
    private _address: string = ''


    get title(): string {
        return this._title;
    }

    set title(value: string) {
        this._title = value;
    }

    get startDate(): string {
        return this._startDate;
    }

    set startDate(value: string) {
        this._startDate = value;
    }

    get endDate(): string {
        return this._endDate;
    }

    set endDate(value: string) {
        this._endDate = value;
    }

    get address(): string {
        return this._address;
    }

    set address(value: string) {
        this._address = value;
    }
}